import styled from "styled-components";
import { Select } from "antd";

export const RASelect = ({
	onChange,
	onSearch,
	options = [],
	showSearch = false,
	placeholder = "",
	optionLabelProp = "label",
	mode,
	value,
	disabled,
	"data-testid": dataTestId = null,
	...props
}) => (
	<ContainerSelect>
		<Select
			showSearch={showSearch}
			placeholder={placeholder}
			optionFilterProp="children"
			optionLabelProp={optionLabelProp}
			value={value}
			mode={mode}
			disabled={disabled}
			onChange={onChange}
			onSearch={onSearch}
			options={options}
			style={{ width: "100%" }}
			filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
			data-testid={dataTestId}
			{...props}
		/>
	</ContainerSelect>
);

const ContainerSelect = styled.div`
	width: 100%;

	.ant-select {
		min-height: 52px;
		border-radius: 10px;
		&:hover {
			outline: none;
			border-color: #ffb11a !important;
		}
	}
	.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover
		.ant-select-selector {
		border-color: #ffb11a !important;
	}
	.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		background: transparent;
	}
	.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
		min-height: 52px;
		align-items: center;
		border-radius: 10px;
		&:hover {
			outline: none;
			border-color: #ffb11a !important;
		}
	}
	.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		min-height: 52px;
	}
	.ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
		background-color: #fafafa !important;
	}
	.ant-select-dropdown .ant-select-item-option-state {
		display: none;
	}
`;
